import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../../models';
import { ApiService } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private api: ApiService) { }

  public get(): Observable<User> {
    return this.api.get<User>('api/user');
  }
}
